import { atom } from 'jotai';
import { PLAYER_DATA_LOCKER_DEFAULT_COLUMNS } from '@/consts/dataLocker/player';
import { TEAM_SQUAD_TABLE_COLUMNS_TO_EXCLUDE } from '@/consts/squad';

export const playerDataDefaultColumnsAtom = atom(() => [...PLAYER_DATA_LOCKER_DEFAULT_COLUMNS]);

const SQUAD_COLUMNS = PLAYER_DATA_LOCKER_DEFAULT_COLUMNS.filter(
  column => !TEAM_SQUAD_TABLE_COLUMNS_TO_EXCLUDE.includes(column),
);

export const teamSquadDefaultColumnsAtom = atom(SQUAD_COLUMNS);
